import { render, staticRenderFns } from "./RegisterOnlinePayment.vue?vue&type=template&id=27df15f1&"
import script from "./RegisterOnlinePayment.vue?vue&type=script&lang=js&"
export * from "./RegisterOnlinePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports